// LIBRARIES
import styled from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const RentStatisticElement = styled.div`
  width: 96%;
  height: 90%;
  margin: 20px 20px 0 0;
  background-color: #F5F5F5;
  border-radius: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media (${WIDTH.tabletWidth}) {
    width: 290px;
  }
`;

export const RentStatisticElementContent = styled.div`
  display: flex;
  align-items: center;
  margin-left: 19px;
`;

export const ImageContainer = styled.div`
  width: 60px;
  height: 60px;
  background-image: linear-gradient(
    223deg,
    ${COLORS.rainbowIndigo} 0%,
    ${COLORS.rainbowIndigo} 100%
  );
  border-radius: 5px;
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextContainer = styled.div`
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  font-family: ${FONTS.newsharp};
`;

export const TextContainerSubtitle = styled.div`
  color: ${COLORS.cornflowerBlue};
  font-size: 20px;
  font-weight: bold;
  margin-top: 1px;
`;

export const TextContainerInfo = styled.div`
  font-size: 26px;
  font-weight: bold;
  margin-top: 5px;
`;
